import React from 'react'
// c:\xampp\htdocs\miners-market-main\components\RebuildMatrixForm.js

import { formatNumberWithCommas } from '../utils/shared.js';
import AccordionSection from './AccordionSection.jsx';
import MediaManager from './forms/MediaManager.jsx';

const REBUILD_MATRIX_DATA = {
    "Powertrain & Drivetrain": ["Engine", "Transmission", "Drive", "Differential", "Clutch / Torque Converter", "Turbo / Supercharger", "Exhaust System", "Pump Drive", "Custom 1 (Powertrain)", "Custom 2 (Powertrain)", "Custom 3 (Powertrain)", "Custom 4 (Powertrain)", "Custom 5 (Powertrain)"],
    "Hydraulic, Fuel & Fluid Systems": ["Hydraulic System (Pumps, Motors, Valves, Piping)", "Fuel System (Pump, Sensors, Valves, Piping)", "Diesel Supply / Tanks", "Piping & Fittings", "Cooling System (Radiator, Fans, Piping)", "Lubrication Systems", "Fluid Flush & Replacement", "Air System (Pump, Motor, Valves, Sensors, Piping)", "Feed Beam", "Stabilizers", "Reeler", "Custom 1 (Hydraulic)", "Custom 2 (Hydraulic)", "Custom 3 (Hydraulic)", "Custom 4 (Hydraulic)", "Custom 5 (Hydraulic)"],
    "Electrical & Electronic Systems": ["Wiring", "ECU / Control Modules", "Sensors & Actuators", "Battery & Charging System", "Starter & Alternator", "Display Screens & Instrument Panels", "GPS / Telematics Systems", "Lights", "CAS Level 9 System", "Slip Ring Cabinet", "Custom 1 (Electrical)", "Custom 2 (Electrical)", "Custom 3 (Electrical)", "Custom 4 (Electrical)", "Custom 5 (Electrical)"],
    "Structure, Chassis & Frame": ["Mainframe", "MAST/FEED", "Cab / ROPS / FOPS", "Articulated Carrier", "Custom 1 (Structure)", "Custom 2 (Structure)", "Custom 3 (Structure)", "Custom 4 (Structure)", "Custom 5 (Structure)"],
    "Safety Systems": ["Fire Suppression", "Emergency Stop Systems", "Steps, Handrails & Guarding", "Custom 1 (Safety)", "Custom 2 (Safety)", "Custom 3 (Safety)", "Custom 4 (Safety)", "Custom 5 (Safety)"],
    "Wear Components & Running Gear": ["Tyres", "Rims & Wheels", "GET (Ground Engaging Tools)", "Bearings & Bushes", "Pins & Liners", "Tracks / Undercarriage (If Applicable)", "Custom 1 (Wear)", "Custom 2 (Wear)", "Custom 3 (Wear)", "Custom 4 (Wear)", "Custom 5 (Wear)"],
    "Bodywork, Cab & Visibility": ["Bodywork & Paint", "Windows", "Interior Trim", "Decals & Branding", "Corrosion Treatment", "Custom 1 (Bodywork)", "Custom 2 (Bodywork)", "Custom 3 (Bodywork)", "Custom 4 (Bodywork)", "Custom 5 (Bodywork)"],
    "Compliance, Legal & Identification": ["DMR Compliance", "Roadworthiness / Safety Certification", "Signage", "Custom 1 (Compliance)", "Custom 2 (Compliance)", "Custom 3 (Compliance)", "Custom 4 (Compliance)", "Custom 5 (Compliance)"],
    "Operators Cab": ["Pedals", "Steering Wheel", "Seat", "Seatbelt", "Estop", "Joysticks", "Controls", "Custom 1 (Operators Cab)", "Custom 2 (Operators Cab)", "Custom 3 (Operators Cab)", "Custom 4 (Operators Cab)", "Custom 5 (Operators Cab)"],
    "Drifters / Rock Drill": ["Custom 1 (Drifters)", "Custom 2 (Drifters)", "Custom 3 (Drifters)", "Custom 4 (Drifters)", "Custom 5 (Drifters)"]
};

const COMPONENT_TYPES = {
    "Powertrain & Drivetrain": "A", 
    "Hydraulic, Fuel & Fluid Systems": "B",
    "Electrical & Electronic Systems": "C",
    "Structure, Chassis & Frame": "D",
    "Safety Systems": "E",
    "Wear Components & Running Gear": "F",
    "Bodywork, Cab & Visibility": "G",
    "Compliance, Legal & Identification": "H",
    "Operators Cab": "I",
    "Drifters / Rock Drill": "J"
};

// New component for the special inspection/service section
export default function InspectionServiceForm({ details, onUpdate, openSection, onToggle }) {
    const inspectionItems = ["Full Service", "Operational Testing", "Safety Audit", "Final Quality Sign-Off"];
    const conditionItems = ["Good clean runner", "Rebuild to zero base", "Spares only/Service exchange", "As-is", "Custom requirement"];

    const handleCheckboxChange = (item, value) => {
        onUpdate(item, 'selected', value);
    };

    const handleCommentChange = (item, comment) => {
        onUpdate(item, 'comment', comment);
    };

    return (
        <AccordionSection title="Final Inspection & Service" id="FinalInspectionService" openSection={openSection} onToggle={onToggle}>
            <div className="p-4 space-y-6">
                <div>
                    <h4 className="font-medium text-gray-800 mb-3">Inspection & Service Status</h4>
                    {inspectionItems.map(item => (
                        <div key={item} className="mb-3 p-3 border rounded-md bg-gray-50/50">
                            <div className="flex items-center space-x-4">
                                <span className="flex-grow font-medium text-gray-700">{item}</span>
                                <label className="flex items-center space-x-2 cursor-pointer">
                                    <input type="radio" name={`radio-${item}`} checked={details[item]?.selected === 'yes'} onChange={() => handleCheckboxChange(item, 'yes')} className="form-radio text-blue-600" />
                                    <span>Yes</span>
                                </label>
                                <label className="flex items-center space-x-2 cursor-pointer">
                                    <input type="radio" name={`radio-${item}`} checked={details[item]?.selected === 'no'} onChange={() => handleCheckboxChange(item, 'no')} className="form-radio text-gray-500" />
                                    <span>No</span>
                                </label>
                            </div>
                            {item === "Operational Testing" && details[item]?.selected === 'yes' && (
                                <div className="mt-2 pl-4">
                                    <label className="text-xs font-medium text-gray-500">Comments</label>
                                    <input 
                                        type="text" 
                                        value={details[item]?.comment || ''} 
                                        onChange={(e) => handleCommentChange(item, e.target.value)} 
                                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm" 
                                        placeholder="Add comments for operational testing..."
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div>
                    <h4 className="font-medium text-gray-800 mb-3">Final Machine Condition (Seller Agreed Options for Buyer)</h4>
                    {conditionItems.map(item => (
                        <div key={item} className="mb-2">
                            <div className="flex items-center">
                                <label className="flex items-center space-x-4 cursor-pointer">
                                    <input type="checkbox" checked={details[item]?.selected === 'yes'} onChange={(e) => handleCheckboxChange(item, e.target.checked ? 'yes' : 'no')} className="form-checkbox h-5 w-5 text-blue-600 rounded" />
                                    <span className="font-medium text-gray-700">{item}</span>
                                </label>
                            </div>
                            {item === "Custom requirement" && details[item]?.selected === 'yes' && (
                                <div className="mt-2 pl-9">
                                    <label className="text-xs font-medium text-gray-500">Please specify*</label>
                                    <input 
                                        type="text"
                                        value={details[item]?.comment || ''}
                                        onChange={(e) => handleCommentChange(item, e.target.value)}
                                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm"
                                        placeholder="Describe custom requirement..."
                                        required
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </AccordionSection>
    );
}

function Dropdown({ label, name, value, options, onChange, disabled = false, required = false }) {
    return (
        <div>
            <label className="text-xs font-medium text-gray-500 block mb-1">{label}{required && '*'}</label>
            <select name={name} value={value || ''} onChange={onChange} disabled={disabled} required={required} className={`mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}>
                <option value="" disabled>Select...</option>
                {options && options.map && options.map(opt => (
                    <option key={opt} value={typeof opt === 'object' ? opt.value : opt}>{typeof opt === 'object' ? opt.label : opt}</option>
                ))}
            </select>
        </div>
    );
}

// Sub-component for a single matrix item
function MatrixItem({ item, details, onUpdate, category, componentType }) {
    const isSelected = details?.selected || false;
    const isNotApplicable = details?.not_applicable || false;

    const isCustom = item.startsWith('Custom ');
    const [isUploading, setIsUploading] = React.useState(false);
    const fileInputRef = React.useRef(null);
    const cameraInputRef = React.useRef(null);
    const docInputRef = React.useRef(null);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        onUpdate(item, name, checked);
    };

    const handleDamageTypeChange = (e) => {
        const { name, checked } = e.target;
        let newDamageTypes = { ...(details?.damage_types || {}), [name]: checked };

        if (name === 'None' && checked) {
            // If 'None' is checked, uncheck all others.
            Object.keys(newDamageTypes).forEach(key => {
                if (key !== 'None') newDamageTypes[key] = false;
            });
        } else if (name !== 'None' && checked) {
            // If another option is checked, uncheck 'None'.
            newDamageTypes['None'] = false;
        }

        onUpdate(item, 'damage_types', newDamageTypes);
    };
    
    const handleInputChange = (e) => {
        let { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? checked : value;
        onUpdate(item, name, val);
    };

    const handleImageUpload = async (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        const currentImages = details?.images || (details?.image_url ? [details.image_url] : []);
        if (currentImages.length + files.length > 4) {
            alert(`You can only upload a maximum of 4 images. You currently have ${currentImages.length}.`);
            e.target.value = ''; // Reset input
            return;
        }

        // --- NEW: Client-side file size validation (100MB max) ---
        const maxSize = 100 * 1024 * 1024; // 100MB in bytes
        const oversizedFiles = files.filter(f => f.size > maxSize);
        if (oversizedFiles.length > 0) {
            alert(`File(s) exceed 100MB limit: ${oversizedFiles.map(f => f.name).join(', ')}`);
            e.target.value = ''; // Reset input
            return;
        }

        setIsUploading(true);
        const newUrls = [];

        try {
            for (const file of files) {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('type', 'image'); // Explicitly set type for new upload_files.php

                const response = await fetch('/api/upload_files.php', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData
                });
                
                const result = await response.json();
                const uploadedUrl = result.url || (result.urls ? Object.values(result.urls)[0] : null);
                if (result.success && uploadedUrl) {
                    newUrls.push(uploadedUrl);
                } else {
                    console.error("Matrix image upload failed:", result);
                    alert(`Failed to upload ${file.name}: ${result.message}`);
                }
            }

            if (newUrls.length > 0) {
                const updatedImages = [...currentImages, ...newUrls];
                onUpdate(item, 'images', updatedImages);
                if (details?.image_url) onUpdate(item, 'image_url', null); // Clear legacy field
            }
        } catch (err) {
            console.error("Upload failed", err);
            alert("Failed to upload image.");
        } finally {
            setIsUploading(false);
            e.target.value = '';
        }
    };

    const handleRemoveImage = (indexToRemove) => {
        const currentImages = details?.images || (details?.image_url ? [details.image_url] : []);
        const updatedImages = currentImages.filter((_, index) => index !== indexToRemove);
        onUpdate(item, 'images', updatedImages);
        if (details?.image_url) onUpdate(item, 'image_url', null);
    };

    const handleChooseFilesClick = () => fileInputRef.current.click();
    const handleTakePhotoClick = () => cameraInputRef.current.click();
    const handleChooseDocsClick = () => docInputRef.current.click();

    const renderFields = () => {
      const commonFields = (
            <>
                <div>
                    <label className="text-xs font-medium text-gray-500">Comments/Description*</label>
                    <input 
                        type="text" 
                        name="comment" 
                        value={details?.comment || ''} 
                        onChange={handleInputChange} 
                        required 
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm"
                        placeholder="Add a note..."
                    />
                </div>
                <div>
                    <label className="text-xs font-medium text-gray-500">Additional Information (Optional)</label>
                    <input type="text" name="additional_info" value={details?.additional_info || ''} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm" placeholder="Any extra details..." />
                </div>
                <div className="sm:col-span-2">
                    <label className="text-xs font-medium text-gray-500 block mb-2">Evidence Photos (Max 4)</label>
                    <p className="text-xs text-gray-400 mb-2">Supported formats: JPEG, PNG. Recommended size: 800x800px.</p>
                    <div className="flex space-x-2 mb-3">
                        <button type="button" onClick={handleChooseFilesClick} disabled={isUploading} className="flex items-center px-3 py-2 border border-gray-300 rounded text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50">
                            <i className="fas fa-folder-open mr-2"></i> Choose Files
                        </button>
                        <button type="button" onClick={handleTakePhotoClick} disabled={isUploading} className="flex items-center px-3 py-2 border border-gray-300 rounded text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50">
                            <i className="fas fa-camera mr-2"></i> Take Photo
                        </button>
                    </div>
                    <input type="file" ref={fileInputRef} onChange={handleImageUpload} multiple accept="image/*" className="hidden" />
                    <input type="file" ref={cameraInputRef} onChange={handleImageUpload} accept="image/*" capture="environment" className="hidden" />
                    
                    {isUploading && <div className="text-xs text-blue-600 mb-2"><i className="fas fa-spinner fa-spin mr-1"></i>Uploading...</div>}
                    
                    <div className="flex flex-wrap gap-2">
                        {(details?.images || (details?.image_url ? [details.image_url] : [])).map((url, idx) => (
                            <div key={idx} className="relative group">
                                <img src={url} alt={`Evidence ${idx}`} className="h-16 w-16 object-cover rounded border" />
                                <button onClick={() => handleRemoveImage(idx)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-opacity" title="Remove photo">&times;</button>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        );

        const CONDITION_OPTIONS = ['New', 'Refurb', 'AS-IS', 'Service Only'];

        switch(componentType) {
            case 'A': // Powertrain & Drivetrain
                if (item.startsWith('Custom')) {
                    // Logic for "Other"
                    return <div className="grid sm:grid-cols-2 gap-4">
                        <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={CONDITION_OPTIONS} required />
                        <Dropdown label="Runner" name="runner" value={details?.runner} onChange={handleInputChange} options={['Yes', 'No']} />
                        <Dropdown
                            label="Rotating / Hour-Based Component?"
                            name="is_hour_based"
                            value={details?.is_hour_based}
                            onChange={handleInputChange}
                            options={['Yes', 'No']}
                            required
                        />
                        {details?.is_hour_based === 'Yes' &&
                            <div>
                                <div className="flex justify-between items-center mb-1">
                                    <label className="text-xs font-medium text-gray-500">Component Hours*</label>
                                    <label className="flex items-center text-xs text-gray-600 cursor-pointer">
                                        <input type="checkbox" name="hours_na" checked={!!details?.hours_na} onChange={handleInputChange} className="h-4 w-4 rounded mr-1 text-blue-600" />
                                        N/A
                                    </label>
                                </div>
                                <input type="text" name="hours" value={details?.hours ?? ''} onChange={handleInputChange} disabled={!!details?.hours_na} required={!details?.hours_na} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm disabled:bg-gray-100" placeholder="e.g., 500" />
                            </div>
                        }
                        {commonFields}
                    </div>;
                } else if (item === 'Exhaust System') {
                    // Logic for "Exhaust System" (no hours)
                    return <div className="grid sm:grid-cols-2 gap-4">
                        <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={CONDITION_OPTIONS} required />
                        {/* No hours, no runner */}
                        {commonFields}
                    </div>;
                } else {
                    // Logic for all other Powertrain components
                    const isTestable = ['Engine', 'Drive', 'Transmission', 'Differential', 'Clutch / Torque Converter', 'Turbo / Supercharger', 'Pump Drive'].includes(item);
                    return <div className="grid sm:grid-cols-2 gap-4">
                        <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={CONDITION_OPTIONS} required  />
                        {isTestable && <Dropdown label="Runner" name="runner" value={details?.runner} onChange={handleInputChange} options={['Yes', 'No']} />}
                        <div>
                            <div className="flex justify-between items-center mb-1">
                                <label className="text-xs font-medium text-gray-500">Component Hours*</label>
                                <label className="flex items-center text-xs text-gray-600 cursor-pointer">
                                    <input type="checkbox" name="hours_na" checked={!!details?.hours_na} onChange={handleInputChange} className="h-4 w-4 rounded mr-1 text-blue-600" />
                                    N/A
                                </label>
                            </div>
                                <input type="text" name="hours" value={details?.hours ?? ''} onChange={handleInputChange} disabled={!!details?.hours_na} required={!details?.hours_na} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm disabled:bg-gray-100" placeholder="e.g., 500" />
                        </div>
                        {commonFields}
                    </div>;
                }
            case 'B': // Hydraulic, Fuel & Fluid Systems
                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={CONDITION_OPTIONS} />
                    <Dropdown label="System Status" name="system_status" value={details?.system_status} onChange={handleInputChange} options={['Operational', 'Normal Wear', 'Damage', 'Leaking', 'Requires Kit']} />
                    {commonFields}
                </div>;
            case 'C': // Electrical & Electronic Systems
                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Installed" name="installed" value={details?.installed} onChange={handleInputChange} options={['Yes', 'No']} />
                    <Dropdown label="Operational Status" name="operational_status" value={details?.operational_status} onChange={handleInputChange} options={['Operational', 'Intermittent Fault', 'Non-Operational']} />
                    {commonFields}
                </div>;
            case 'D': // Structure, Chassis & Frame
                const damageTypes = [
                    "Structural Damage", "Weld & Joint Issues", "Corrosion & Fatigue", 
                    "Impact / Load Damage", "Mounting & Attachment Issues", "Previous Repairs", "Safety / Compliance", "None"
                ];
                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={['Good', 'Minor Wear', 'Damage Present', 'Structural Repair Required']} />
                    <div className="sm:col-span-2">
                        <label className="text-xs font-medium text-gray-500 block mb-2">Damage Type</label>
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2 p-3 border rounded-md bg-white">
                            {damageTypes.map(type => (
                                <label key={type} className="flex items-center text-sm">
                                    <input
                                        type="checkbox"
                                        name={type}
                                        checked={!!details?.damage_types?.[type]}
                                        onChange={handleDamageTypeChange}
                                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                    />
                                    <span className="ml-2 text-gray-700">{type}</span>
                                </label>
                            ))}
                        </div>
                    </div>
                    {commonFields}
                </div>;
            case 'E': // Safety Systems

                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Installed" name="installed" value={details?.installed} onChange={handleInputChange} options={['Yes', 'No']} />
                    <Dropdown label="Operational" name="operational" value={details?.operational} onChange={handleInputChange} options={['Yes', 'No']} />
                    <Dropdown label="Compliance Status" name="compliance_status" value={details?.compliance_status} onChange={handleInputChange} options={['Compliant', 'Non-Compliant', 'Not Required', 'Requires Certification']} />
                    {commonFields}
                </div>;
            case 'F': // Wear Components & Running Gear
                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={['New', 'Good', 'Replace Soon', 'End of Life']} />
                    <Dropdown label="Wear Level" name="wear_level" value={details?.wear_level} onChange={handleInputChange} options={['0-25%', '25-50%', '50-75%', '75-100%']} />
                    {commonFields}
                </div>;
            case 'G': // Bodywork, Cab & Visibility
                const showCorrosion = ['Bodywork & Paint', 'Corrosion Treatment'].includes(item);
                if (item === 'Windows') {
                    const isClosedCab = details?.cab_type === 'closed';
                    return <div className="space-y-4">
                        <div>
                            <label className="text-xs font-medium text-gray-500 block mb-2">Cab Type</label>
                            <div className="flex space-x-6">
                                <label className="flex items-center">
                                    <input type="radio" name="cab_type" value="open" checked={details?.cab_type === 'open'} onChange={handleInputChange} className="form-radio h-5 w-5 text-blue-600" />
                                    <span className="ml-2 text-sm">Open Cab</span>
                                </label>
                                <label className="flex items-center">
                                    <input type="radio" name="cab_type" value="closed" checked={details?.cab_type === 'closed'} onChange={handleInputChange} className="form-radio h-5 w-5 text-blue-600" />
                                    <span className="ml-2 text-sm">Closed Cab</span>
                                </label>
                            </div>
                        </div>
                        <div className={`space-y-4 ${!isClosedCab ? 'opacity-50 pointer-events-none' : ''}`}>
                            <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={['Good', 'Minor Damage', 'Needs Repair', 'Severe Damage']} disabled={!isClosedCab} required={isClosedCab} />
                            {commonFields}
                        </div>
                    </div>;
                }
                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={['Good', 'Minor Damage', 'Needs Repair', 'Severe Damage']} />
                    {showCorrosion && <Dropdown label="Corrosion Status" name="corrosion_status" value={details?.corrosion_status} onChange={handleInputChange} options={['None', 'Surface', 'Moderate', 'Severe']} />}
                    {commonFields}
                </div>;
            case 'H': // Compliance, Legal & Identification
                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Present" name="present" value={details?.present} onChange={handleInputChange} options={['Yes', 'No']} />
                    <Dropdown label="Legible" name="legible" value={details?.legible} onChange={handleInputChange} options={['Yes', 'No']} />
                    <Dropdown label="Compliance Status" name="compliance_status" value={details?.compliance_status} onChange={handleInputChange} options={['Compliant', 'Non-Compliant', 'Not Required', 'Requires Certification']} />
                    
                    <div className="sm:col-span-2">
                            <label className="text-xs font-medium text-gray-500 block mb-2">Evidence Documents (Max 4)</label>
                            <p className="text-xs text-gray-400 mb-2">Supported formats: PDF. </p>
                            <div className="flex space-x-2 mb-3">
                                <button type="button" onClick={handleChooseDocsClick} disabled={isUploading} className="flex items-center px-3 py-2 border border-gray-300 rounded text-xs font-medium text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50">
                                    <i className="fas fa-folder-open mr-2"></i> Choose Files
                                </button>
                                <input type="file" ref={docInputRef} onChange={handleImageUpload} multiple accept=".pdf,application/pdf" className="hidden" />
                            </div>
                            <div className="flex flex-wrap gap-2">
                                {(details?.images || (details?.image_url ? [details.image_url] : [])).map((url, idx) => (
                                    <div key={idx} className="relative group">
                                        <a href={url} target="_blank" rel="noopener noreferrer" className="h-16 w-16 flex items-center justify-center bg-gray-100 border rounded text-red-500"><i className="fas fa-file-pdf text-2xl"></i></a>
                                        <button onClick={() => handleRemoveImage(idx)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-opacity" title="Remove document">&times;</button>
                                    </div>
                                ))}
                            </div>
                    </div>
                    <div>
                        <label className="text-xs font-medium text-gray-500">Comments/Description*</label>
                        <input 
                        type="text"
                        name="comment"
                        value={details?.comment || ''}
                        onChange={handleInputChange}
                        required
                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm"
                        placeholder="Add a note..."
                    />
                    </div>
                    <div>
                        <label className="text-xs font-medium text-gray-500">Additional Information (Optional)</label>
                        <input type="text" name="additional_info" value={details?.additional_info || ''} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm" placeholder="Any extra details..." />
                    </div>
                </div>;
            case 'I': // Operators Cab
                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={['Good', 'Minor Wear', 'Damage Present', 'Needs Replacement']} />
                    <Dropdown label="Operational" name="operational" value={details?.operational} onChange={handleInputChange} options={['Yes', 'No']} />
                    {commonFields}
                </div>;
            case 'J': // Drifters / Rock Drill
                const CONDITION_OPTIONS = ['New', 'Refurb', 'AS-IS', 'Service Only'];
                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={CONDITION_OPTIONS} required />
                    <Dropdown label="Runner" name="runner" value={details?.runner} onChange={handleInputChange} options={['Yes', 'No']} />
                    <div>
                        <div className="flex justify-between items-center mb-1">
                            <label className="text-xs font-medium text-gray-500">Component Hours*</label>
                            <label className="flex items-center text-xs text-gray-600 cursor-pointer">
                                <input type="checkbox" name="hours_na" checked={!!details?.hours_na} onChange={handleInputChange} className="h-4 w-4 rounded mr-1 text-blue-600" />
                                N/A
                            </label>
                        </div>
                        <input type="text" name="hours" value={details?.hours ?? ''} onChange={handleInputChange} disabled={!!details?.hours_na} required={!details?.hours_na} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm disabled:bg-gray-100" placeholder="e.g., 500" />
                    </div>
                    {commonFields}
                </div>;
            default:
                // Fallback for unknown component types (legacy data)
                return <div className="grid sm:grid-cols-2 gap-4">
                    <Dropdown label="Condition" name="condition" value={details?.condition} onChange={handleInputChange} options={['New', 'Refurb', 'AS-IS', 'Service Only']} />
                    <Dropdown label="Runner" name="runner" value={details?.runner} onChange={handleInputChange} options={['Yes', 'No']} />
                    {commonFields}
                </div>;
        }
    }

 return (
        <div className={`p-4 border-b last:border-b-0 ${isSelected ? 'bg-blue-50' : 'bg-white'}`} >
            <div className="flex items-center justify-between">
                <label className="flex items-center space-x-3 cursor-pointer">
                    <input type="checkbox" name="selected" checked={isSelected} onChange={handleCheckboxChange} className="h-5 w-5 text-blue-600 rounded" />
                    <span className="font-medium text-gray-800">{isCustom ? 'Custom' : item.replace(/ \(.*/, '')}</span>
                </label>
            </div>
            {isSelected && (
                <div className="pl-8 mt-4 space-y-4 animate-fade-in">
                    <div className="flex items-center p-2 bg-gray-50 rounded-md border">
                        <input
                            type="checkbox"
                            id={`not-applicable-${item.replace(/[^a-zA-Z0-9]/g, '')}`}
                            name="not_applicable"
                            checked={isNotApplicable}
                            onChange={handleInputChange}
                            className="h-4 w-4 text-blue-600 rounded mr-2"
                        />
                        <label htmlFor={`not-applicable-${item.replace(/[^a-zA-Z0-9]/g, '')}`} className="text-sm font-medium text-gray-700">Not Applicable</label>
                    </div>

                    {isCustom && (
                        <div>
                            <label className="text-xs font-medium text-gray-500 block mb-1">Specify Component Name*</label>
                            <input type="text" name="other_name" value={details?.other_name || ''} onChange={handleInputChange} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm" placeholder="e.g., Auxiliary Pump" required />
                        </div>
                    )}
                    <fieldset disabled={isNotApplicable} className={isNotApplicable ? 'opacity-50' : ''}>
                        {renderFields()}
                    </fieldset>
                </div>
            )}
        </div>
    );
}








function RebuildMatrixForm({ formData, onFormChange, openSection, onToggleSection }) {
    const [error, setError] = React.useState(null);

    // Migration function to handle legacy draft data - PRESERVES ALL DATA
    const migrateRebuildDetails = (details) => {
        try {
            // Return all details as-is to preserve user progress
            // The rendering logic will handle items that may not match current structure
            return details || {};
        } catch (e) {
            console.error("Error migrating rebuild details:", e);
            return {};
        }
    };

    const rebuildDetails = migrateRebuildDetails(formData.rebuild_details || {});

    // If there's an error, show a user-friendly message
    if (error) {
        return (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-700 font-medium">Error loading rebuild matrix</p>
                <p className="text-red-600 text-sm mt-1">{error}</p>
                <button 
                    onClick={() => setError(null)}
                    className="mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                >
                    Retry
                </button>
            </div>
        );
    }

    const handleItemUpdate = (item, field, value) => {
        try {
            const newDetails = { ...rebuildDetails };
            if (!newDetails[item]) newDetails[item] = {};
            newDetails[item][field] = value;

            // When 'Not Applicable' is checked, clear out other fields but keep 'selected' and 'not_applicable'
            if (field === 'not_applicable' && value === true) {
                const preserved = {
                    selected: newDetails[item].selected,
                    not_applicable: true
                };
                if (newDetails[item].other_name) {
                    preserved.other_name = newDetails[item].other_name;
                }
                newDetails[item] = preserved;
            }

            // if cab_type is open, clear window details
            if (item === 'Windows' && field === 'cab_type' && value === 'open') {
                newDetails[item].condition = '';
                newDetails[item].comment = '';
                newDetails[item].additional_info = '';
                newDetails[item].images = [];
                newDetails[item].image_url = null;
            }

            // if hours_na is checked, clear hours
            if (field === 'hours_na' && value === true) {
                newDetails[item].hours = '';
            }
            if (field === 'not_applicable' && value === false){

            }
            if (field === 'selected' && !value) delete newDetails[item];
            onFormChange({ target: { name: 'rebuild_details', value: newDetails } });
        } catch (e) {
            console.error("Error updating rebuild details:", e);
            setError("Failed to update item. Please try again.");
        }
    };

    try {
        return (
            <div className="space-y-2">
                {Object.entries(REBUILD_MATRIX_DATA).map(([category, items]) => (
                    <AccordionSection key={category} title={category} id={category.replace(/[^a-zA-Z0-9]/g, '')} openSection={openSection} onToggle={onToggleSection}>
                        <div className="divide-y divide-gray-200">
                            {items.map(item => (
                                <MatrixItem 
                                    key={item} 
                                    item={item} 
                                    details={rebuildDetails[item]} 
                                    onUpdate={handleItemUpdate} 
                                    category={category} 
                                    componentType={COMPONENT_TYPES[category] || 'default'} 
                                />
                            ))}
                        </div>
                    </AccordionSection>
                ))}
                <InspectionServiceForm details={rebuildDetails} onUpdate={handleItemUpdate} openSection={openSection} onToggle={onToggleSection} />
            </div>
        );
    } catch (e) {
        console.error("Error rendering RebuildMatrixForm:", e);
        setError("Failed to load rebuild matrix. Your draft data may be incompatible with the current form structure. Please contact support.");
        return (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-700 font-medium">Error loading rebuild matrix</p>
                <p className="text-red-600 text-sm mt-1">{error || "Failed to load rebuild matrix. Your draft data may be incompatible with the current form structure. Please contact support."}</p>
                <button
                    onClick={() => setError(null)}
                    className="mt-2 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                >
                    Retry
                </button>
            </div>
        );
    }
}
